export default __webpack_public_path__ + "static/media/cartoon_galaxy_background.ea2d35eb.png";